module.exports = __webpack_public_path__ + "static/media/trash_icon_gray.447a5a42.svg";